import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetBreastMriLesionsByPatientId, GetBreastMriLesionsByPatientIdResponse } from "../../api/dtos";
import { useGet } from "@ngt/opms";


const getData = (response?: SWRResponse<GetBreastMriLesionsByPatientIdResponse, GetBreastMriLesionsByPatientIdResponse>) => response?.data?.lesions;
const getError = (response?: SWRResponse<GetBreastMriLesionsByPatientIdResponse, GetBreastMriLesionsByPatientIdResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useBreastMriLesionsByPatientId = (patientId?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!patientId) return undefined;

        return () => {
            return new GetBreastMriLesionsByPatientId({patientId});
        }
    }, [patientId]);

    return useGet(request, { getData, getError }, configuration);
}


export default useBreastMriLesionsByPatientId;